// extracted by mini-css-extract-plugin
export default {"img":"Project_img__ebu+c","btn":"Project_btn__g07Ku"};